import type { TimelineItem } from "@/mocks/topics";

export default function EventTimeline({ items }: { items: TimelineItem[] }) {
  return (
    <section id="timeline" className="scroll-mt-24">
      <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">事件时间线</h2>
      <p className="mt-2 font-label text-sm text-foreground-600">
        标注各方自述的时间点，冲突区间通常就藏在重叠的部分里。
      </p>

      <ol className="mt-6 space-y-0">
        {items.map((item, index) => (
          <li key={`${item.date}-${index}`} className="relative flex gap-4 pb-6 last:pb-0">
            <div className="flex flex-col items-center">
              <span
                className={`flex h-3 w-3 flex-none rounded-full ${
                  index === items.length - 1 ? "bg-primary-500" : "bg-accent-500"
                }`}
              ></span>
              {index !== items.length - 1 && (
                <span className="mt-1 w-px flex-1 bg-background-300"></span>
              )}
            </div>
            <div className="-mt-1 flex-1 rounded-lg border border-background-200 bg-background-50 p-4">
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                <span className="font-label text-xs font-medium text-primary-700">{item.date}</span>
                <h3 className="font-heading text-sm font-semibold text-foreground-950">
                  {item.title}
                </h3>
              </div>
              <p className="mt-2 font-label text-sm leading-relaxed text-foreground-600">
                {item.desc}
              </p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}